import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import type { FC } from 'react';

import { PageHeader } from '@wf/sw-ui-kit';
import { Mode } from '@wf/components';

import LicenseChildrenTable from '../../components/LicenseChildrenTable';
import ContentContainer from '../../../../components/ContentContainer';

import useLicenseAbbreviation from '../../../../hooks/useLicenseAbbreviation';

import { resetChildren } from '../../store/slices';

const LicenseChildren: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id: parentId } = useParams();

  const licenseAbbreviation = useLicenseAbbreviation();

  useEffect(() => () => void dispatch(resetChildren()), [dispatch]);

  const navigateBack = () => navigate(`../../view/${parentId as string}`, { relative: 'path' });

  return (
    <>
      <PageHeader
        title={t('Child {{licenseAbbreviation}}', { licenseAbbreviation })}
        onNavigateBack={navigateBack}
        mode={Mode.view}
      />
      <ContentContainer>
        <LicenseChildrenTable />
      </ContentContainer>
    </>
  );
};

export default LicenseChildren;
